function sliderCaseStudies() {
    [...document.querySelectorAll('.slider-wrapper-case-studies .splide')]?.forEach(sliderCaseStudy => {
      let splideInstanceCaseStudies;
  
      const wrapper = sliderCaseStudy.closest('.slider-wrapper-case-studies');
      const mobileSpeed = parseInt(wrapper.dataset.mobileSpeed) || 1000;
      const desktopSpeed = parseInt(wrapper.dataset.desktopSpeed) || 1000;
  
      const initSliderCaseStudy = () => {
        const windowWidth = window.innerWidth;
        const type = windowWidth < 1024 ? 'fade' : 'slide';
  
        if (splideInstanceCaseStudies) {
          splideInstanceCaseStudies.destroy();
        }
  
        splideInstanceCaseStudies = new Splide(sliderCaseStudy, {
          type: type,
          speed: window.innerWidth < 1024 ? mobileSpeed : desktopSpeed,
          perPage: 1,
          perMove: 1,
          gap: '1.5rem',
          autoHeight: true,
          lazyload: 'sequential',
          rewind: true,
          mediaQuery: 'min',
          pagination: true,
          autoplay: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          interval: 7000,
          focusableNodes: true,
          easing: 'linear',
          breakpoints: {
            1024: {
              type: 'slide',
              perPage: 1,
              perMove: 1,
              pagination: false,
              fixedWidth: '54.6875rem',
              autoplay: false,
              rewind: false,
              easing: 'cubic-bezier(0.25, 1, 0.5, 1)'
            },
            1366: {
              fixedWidth: '65.875rem',
            }
          },
        }
      );
  
      splideInstanceCaseStudies.on( 'move', function (newIndex, prevIndex, destIndex) {
        const slides = sliderCaseStudy.querySelectorAll('.splide__slide');
        const direction = (newIndex > prevIndex) ? 'right' : 'left';
          
        slides.forEach(function(splideInstanceCaseStudies, index) {
          if (index < destIndex) {
            splideInstanceCaseStudies.classList.add('fade-out');
          } else {
            splideInstanceCaseStudies.classList.remove('fade-out');
          }
        });
      });
  
        splideInstanceCaseStudies.mount();
      };
  
      initSliderCaseStudy();
      window.addEventListener('resize', initSliderCaseStudy);
    });
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    sliderCaseStudies();
  });
  